module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ec-Gd.d2a40560.png";